import clCherryRedMedSq from '../assets/classic-cherryred-med-square.JPG';
import clSkyBlueMedAlm from '../assets/classic-skyblue-med-almond.JPG';
import clLavMistMedAlm from '../assets/classic-lavendermist-med-almond.JPG';
import fnfGoldChromeMedAlm from '../assets/fnf-gold-med-almond.JPG';
import fnfSilverChromeMedSq from '../assets/fnf-silver-med-square.JPG';
import museJetBlkMedSq from '../assets/museum-jetblack-med-square.JPG';
import museHotPinkMedAlm from '../assets/musuem-hotpink-med-almond.JPG'; 
import fnfLemonDropMedSq from '../assets/fnf-lemondrop-med-square.JPG';
import fnfWhiteMedAlm from '../assets/fnf-white-med-almond.JPG';
import fnfRainbowXsSq from '../assets/fnf-rainbow-xshort-square.JPG';
import fnfGoldChromeFrenchShortSq from '../assets/fnf-gold-short-square.JPG';
import clBabyBlueShortSq from '../assets/classic-baby-blue-short-square.JPG'
import clRoyalBlueShortCof from '../assets/classic-royal-blue-short-coffin.JPG'
import clJetBlackMedSq from '../assets/classic-jet-black-medium-square.JPG'
import clWineMedSq from '../assets/classic-wine-medium-square.JPG'
import clSageShCof from '../assets/classic-sage-short-coffin.JPG'
import clRosePetalMedCof from '../assets/classic-rose-petal-medium-coffin.JPG'
import clJetBlkShSq from '../assets/classic-jet-black-short-square.JPG'
import fnfHoloChromeShCof from '../assets/fnf-holo-chrome-short-coffin.JPG'
import clBubblegumMedSq from '../assets/classic-bubblegum-medium-sqaure.JPG'
import clHotPinkShortSq from '../assets/classic-hot-pink-short-square.JPG'
import clCreamPuffShortAlm from '../assets/classic-cream-puff-short-almond.JPG'
import museCowGirlieMedCof from '../assets/museum-cow-girlie-medium-coffin.JPG'
import museGiraffeVibesMedCof from '../assets/museum-giraffe-vibe-medium-coffin.JPG'
import fnfBabyBlueShortCof from '../assets/fnf-baby-blue-short-coffin.JPG'
import museSafariChromeMedSq from '../assets/museum-safrai-chrome-medium-square.JPG'
import museSageCateyeShortAlm from '../assets/museum-sage-cateye-short-almond.JPG'
import museSnakeWebShortAlm from '../assets/museum-snake-web-short-almond.JPG'
import fnfSilverSnowMedAlm from '../assets/fnf-silver-snow-medium-almond.JPG'
import fnfSilverJetMedSq from '../assets/fnf-silver-jet-medium-coffin.JPG'
import fnfGoldWineShortCoff from '../assets/fnf-gold-wine-short-coffin.JPG'
import fnfGoldHunterShortSq from '../assets/fnf-gold-hunter-short-square.JPG'
import museHalloweenMedSq from '../assets/museum-halloween-mix-med-square.JPG'
import museVampPrincessMedSq from '../assets/museum-vampire-princess-med-square.JPG'
import fnfDeepBlueChromeMedAlm from '../assets/fnf-blue-chrome-med-almond.JPG'

// tags: ['celeb-inspired'],        
//     featured: true  

const onHandProducts = [
  {
    id: 'muse-halloween-med-square',
    slug: 'muse-halloween-med-square',
    sku: 'MUS-HH-SQ-M',
    size: 'Large',
    color: 'Halloween Mix',
    style: 'The Museum',
    shape: 'Square',
    length: 'Medium',
    price: '$44.00',
    thumbnail: museHalloweenMedSq,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
    tags: ['Holiday'],
    featured: true
  },
  {
    id: 'muse-vamp-princess-med-square',
    slug: 'muse-vamp-princess-med-square',
    sku: 'MUS-VP-SQ-M',
    size: 'Large',
    color: 'Vampire Princess',
    style: 'The Museum',
    shape: 'Square',
    length: 'Medium',
    price: '$44.00',
    thumbnail: museVampPrincessMedSq,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 0 },
    tags: ['Holiday'],
    featured: true
  },
  {
    id: 'muse-cow-girlie-med-coffin',
    slug: 'muse-cow-girlie-med-coffin',
    sku: 'MUS-CG-COF-M',
    size: 'Medium',
    color: 'Cow Girlie',
    style: 'The Museum',
    shape: 'Coffin',
    length: 'Medium',
    price: '$44.00',
    thumbnail: museCowGirlieMedCof,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'muse-safari-chrome-med-square',
    slug: 'muse-safari-chrome-med-square',
    sku: 'MUS-SC-SQ-M',
    size: 'Large',
    color: 'Safari Chrome',
    style: 'The Museum',
    shape: 'Square',
    length: 'Medium',
    price: '$44.00',
    thumbnail: museSafariChromeMedSq,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
   {
    id: 'muse-sage-cateye-short-almond',
    slug: 'muse-sage-cateye-short-almond',
    sku: 'MUS-SC-ALM-S',
    size: 'Medium',
    color: 'Sage & Gold',
    style: 'The Museum',
    shape: 'Almond',
    length: 'Short',
    price: '$44.00',
    thumbnail: museSageCateyeShortAlm,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'museum-jet-black-medium-square',
    slug: 'museum-jet-black-medium-square',
    sku: 'MUS-JET-SQ-M',
    size: 'Medium',
    color: 'Jet Black',
    style: 'The Museum',
    shape: 'Square',
    length: 'Medium',
    price: '$44.00',
    thumbnail: museJetBlkMedSq,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'museum-snake-web-short-almond',
    slug: 'museum-snake-web-short-almond',
    sku: 'MUS-SW-ALM-S',
    size: 'Small',
    color: 'Sticky Snake',
    style: 'The Museum',
    shape: 'Almond',
    length: 'Short',
    price: '$44.00',
    thumbnail: museSnakeWebShortAlm,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'museum-hot-pink-medium-almond',
    slug:'museum-hot-pink-medium-almond',
    sku: 'MUS-HPK-ALM-M',
    size: 'Medium',
    color: 'Hot Pink',
    style: 'The Museum',
    shape: 'Almondetto',
    length: 'Medium',
    price: '$44.00',
    thumbnail: museHotPinkMedAlm,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'fnf-blue-chrome-med-almond',
    slug: 'fnf-blue-chrome-med-almond',
    sku: 'FNF-BC-COF-M',
    size: 'Medium',
    color: 'Deep Blue Chrome',
    style: 'Frenchie & Friends',
    shape: 'Almond',
    length: 'Medium',
    price: '$33.00',
    thumbnail: fnfDeepBlueChromeMedAlm,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
    tags: ['Holiday'],
    featured: true
  },
  {
    id: 'fnf-giraffe-vibes-med-coffin',
    slug: 'fnf-giraffe-vibes-med-coffin',
    sku: 'FNF-GV-COF-M',
    size: 'Large',
    color: 'Giraffe Vibes',
    style: 'Frenchie & Friends',
    shape: 'Coffin',
    length: 'Medium',
    price: '$33.00',
    thumbnail: museGiraffeVibesMedCof,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'fnf-silver-snow-medium-almond',
    slug:'fnf-silver-snow-medium-almond',
    sku: 'FNF-SSW-ALM-M',
    size: 'Large',
    color: 'Silver Snow',
    style: 'Frenchie & Friends',
    shape: 'Almomd',
    length: 'Medium',
    price: '$33.00',
    thumbnail: fnfSilverSnowMedAlm,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'fnf-silver-jet-medium-coffin',
    slug:'fnf-silver-jet-medium-coffin',
    sku: 'FNF-SJB-COF-M',
    size: 'Medium',
    color: 'Silver Jet',
    style: 'Frenchie & Friends',
    shape: 'Coffin',
    length: 'Medium',
    price: '$33.00',
    thumbnail: fnfSilverJetMedSq,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 0 },
  },
  {
    id: 'fnf-gold-wine-short-coffin',
    slug:'fnf-gold-wine-short-coffin',
    sku: 'FNF-GW-COF-S',
    size: 'Medium',
    color: 'Gold Wine',
    style: 'Frenchie & Friends',
    shape: 'Coffin',
    length: 'Short',
    price: '$33.00',
    thumbnail: fnfGoldWineShortCoff,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'fnf-gold-hunter-short-square',
    slug:'fnf-gold-hunter-short-square',
    sku: 'FNF-GH-SQ-S',
    size: 'Medium',
    color: 'Gold Hunter',
    style: 'Frenchie & Friends',
    shape: 'Square',
    length: 'Short',
    price: '$33.00',
    thumbnail: fnfGoldHunterShortSq,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'fnf-baby-blue-short-coffin',
    slug:'fnf-baby-blue-short-coffin',
    sku: 'FNF-BBL-COF-S',
    size: 'Medium',
    color: 'Baby Blue',
    style: 'Frenchie & Friends',
    shape: 'Coffin',
    length: 'Medium',
    price: '$33.00',
    thumbnail: fnfBabyBlueShortCof,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 0 },
  },
  {
    id: 'fnf-lemon-drop-medium-square',
    slug:'fnf-lemon-drop-medium-square',
    sku: 'FNF-LMN-SQ-M',
    size: 'Medium',
    color: 'Lemon Drop',
    style: 'Frenchie & Friends',
    shape: 'Square',
    length: 'Medium',
    price: '$33.00',
    thumbnail: fnfLemonDropMedSq,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'fnf-white-medium-almond',
    slug: 'fnf-white-medium-almond',
    sku: 'FNF-WHT-ALM-M',
    color: 'Snow White',
    size: 'Medium',
    style: 'Frenchie & Friends',
    shape: 'Almondetto',
    length: 'Medium',
   price: '$33.00',
    thumbnail: fnfWhiteMedAlm,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 0 }, 
  },
  {
    id: 'fnf-rainbow-extra-short-square',
    slug: 'fnf-rainbow-extra-short-square',
    sku: 'FNF-RNBW-SQ-XS',
    size: 'Small',
    color: 'Rainbow',
    style: 'Frenchie & Friends',
    shape: 'Square',
    length: 'Extra Short',
    price: '$33.00',
    thumbnail: fnfRainbowXsSq,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'fnf-holo-chrome-short-coffin',
    slug: 'fnf-holo-chrome-short-coffin',
    sku: 'FNF-HOC-COF-S',
    size: 'Small',
    color: 'Holograpic',
    style: 'Frenchie & Friends',
    shape: 'Coffin',
    length: 'Short',
    price: '$33.00',
    thumbnail: fnfHoloChromeShCof,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'fnf-gold-chrome-french-short-square',
    slug:'fnf-gold-chrome-french-short-square',
    sku: 'FNF-GLD-FR-SQ-S',
    size: 'Medium',
    color: 'Gold Chrome (French)',
    style: 'Frenchie & Friends',
    shape: 'Square',
    length: 'Short',
    price: '$33.00',
    thumbnail: fnfGoldChromeFrenchShortSq,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'fnf-gold-chrome-medium-almond',
    slug:'fnf-gold-chrome-medium-almond',
    sku: 'FNF-GLD-ALM-M',
    size: 'Medium',
    color: 'Gold Chrome',
    style: 'Frenchie & Friends',
    shape: 'Almondetto',
    length: 'Medium',
    price: '$33.00',
    thumbnail: fnfGoldChromeMedAlm,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'fnf-silver-chrome-medium-square',
    slug:'fnf-silver-chrome-medium-square',
    sku: 'FNF-SLV-SQ-M',
    size: 'Medium',
    color: 'Silver Chrome',
    style: 'Frenchie & Friends',
    shape: 'Square', // matched to file name
    length: 'Medium',
    priceCents: 3300,
    thumbnail: fnfSilverChromeMedSq,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'classic-cherry-red-medium-square',
    slug:'classic-cherry-red-medium-square',
    sku: 'CLS-CHRD-SQ-M',
    size: 'Medium',
    color: 'Cherry Red',
    style: 'Classic NeNe',
    shape: 'Square',
    length: 'Medium',
    price: '$22.00',
    thumbnail: clCherryRedMedSq,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'classic-sky-blue-medium-almond',
    slug: 'classic-sky-blue-medium-almond',
    sku: 'CLS-SKY-ALM-M',
    size: 'Medium',
    color: 'Sky Blue',
    style: 'Classic NeNe',
    shape: 'Almondetto',
    length: 'Medium',
    price: '$22.00',
    thumbnail: clSkyBlueMedAlm,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'classic-lavender-mist-medium-almond',
    slug: 'classic-lavender-mist-medium-almond',
    sku: 'CLS-LAV-ALM-M',
    size: 'Medium',
    color: 'Lavender Mist',
    style: 'Classic NeNe',
    shape: 'Almondetto',
    length: 'Medium',
    price: '$22.00',
    thumbnail: clLavMistMedAlm,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'classic-baby-blue-short-square',
    slug: 'classic-baby-blue-short-square',
    sku: 'CLS-BBL-SQ-S',
    size: 'Small',
    color: 'Baby Blue',
    style: 'Classic NeNe',
    shape: 'Square',
    length: 'Short',
    price: '$22.00',
    thumbnail: clBabyBlueShortSq,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'classic-royal-blue-short-coffin',
    slug: 'classic-royal-blue-short-coffin',
    sku: 'CLS-RBL-COF-S',
    size: 'Small',
    color: 'Royal Blue',
    style: 'Classic NeNe',
    shape: 'Coffin',
    length: 'Short',
    price: '$22.00',
    thumbnail: clRoyalBlueShortCof,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'classic-jet-black-medium-square',
    slug: 'classic-jet-black-medium-square',
    sku: 'CLS-BLK-SQ-M',
    size: 'Large',
    color: 'Jet Black',
    style: 'Classic NeNe',
    shape: 'Square',
    length: 'Medium',
    price: '$22.00',
    thumbnail: clJetBlackMedSq,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'classic-wine-medium-square',
    slug: 'classic-wine-medium-square',
    sku: 'CLS-WN-SQ-M',
    size: 'Medium',
    color: 'Wine',
    style: 'Classic NeNe',
    shape: 'Square',
    length: 'Medium',
    price: '$22.00',
    thumbnail: clWineMedSq,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'classic-hot-pink-short-square',
    slug: 'cclassic-hot-pink-short-square',
    sku: 'CLS-HP-SQ-S',
    size: 'Medium',
    color: 'Hot Pink',
    style: 'Classic NeNe',
    shape: 'Square',
    length: 'Short',
    price: '$22.00',
    thumbnail:  clHotPinkShortSq,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },

  {
    id: 'classic-sage-short-coffin',
    slug: 'classic-sage-short-coffin',
    sku: 'CLS-SG-COF-S',
    size: 'Small',
    color: 'Sage',
    style: 'Classic NeNe',
    shape: 'Coffin',
    length: 'Short',
    price: '$22.00',
    thumbnail: clSageShCof,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'classic-rose-petal-medium-coffin',
    slug: 'classic-rose-petal-medium-coffin',
    sku: 'CLS-RP-COF-M',
    size: 'Small',
    color: 'Rose Petal',
    style: 'Classic NeNe',
    shape: 'Coffin',
    length: 'Medium',
    price: '$22.00',
    thumbnail: clRosePetalMedCof,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'classic-jet-black-short-square',
    slug: 'classic-jet-black-short-square',
    sku: 'CLS-JET-SQ-S',
    size: 'Small',
    color: 'Jet Black',
    style: 'Classic NeNe',
    shape: 'Square',
    length: 'Short',
    price: '$22.00',
    thumbnail: clJetBlkShSq,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'classic-bubblegum-medium-square',
    slug: 'fclassic-bubblegum-medium-square',
    sku: 'CLS-BPK-SQ-M',
    size: 'Medium',
    color: 'Bubble Gum',
    style: 'Classic NeNe',
    shape: 'Square',
    length: 'Medium',
    price: '$22.00',
    thumbnail: clBubblegumMedSq,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 1 },
  },
  {
    id: 'classic-cream-puff-short-almond',
    slug: 'classic-cream-puff-short-almond',
    sku: 'CLS-CP-ALM-S',
    size: 'Small',
    color: 'Cream Puff',
    style: 'Classic NeNe',
    shape: 'Almond',
    length: 'Short',
    price: '$22.00',
    thumbnail: clCreamPuffShortAlm,
    isOneOfOne: true,
    inventory: { trackType: 'stock', stockQty: 0 },
  },
];

export const formatPrice = (cents) =>
  (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });


export default onHandProducts;
